import { toRaw } from 'vue'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((app) => {
  console.log('SETUP AR_FRESHDESK')
  const env = toRaw(app.$config).public
  if (!env.arFreshdeskWidgetUrl || !env.arFreshdeskWidgetID) return

  let isInitialized = false

  const initializeFreshdesk = () => {
    window.fwSettings = {
      widget_id: env.arFreshdeskWidgetID,
    }
    !(function () { if ('function' != typeof window.FreshworksWidget) { var n = function () { n.q.push(arguments) }; n.q = [], window.FreshworksWidget = n } }())

    // Load async deferred script
    const script = document.createElement('script')
    script.onload = function () {
      // If necessary
    }
    script.src = env.arFreshdeskWidgetUrl
    script.async = true
    script.defer = true
    document.head.appendChild(script)
  }

  if (!app.$router) {
    return
  }

  /*
  ** Every time the route changes (fired on initialization too)
  */
  app.$router.afterEach(() => {
    const auth = toRaw(app.$store.state.authModule)

    // // An account must be logged in for Freshdesk to be prefilled and initialized.
    if (!auth || !auth.account) {
      return
    }

    if (!isInitialized || window.FreshworksWidget === undefined || window.FreshworksWidget === null) {
      initializeFreshdesk()
      isInitialized = true
      FreshworksWidget('hide', 'launcher')
    }

    // Prefill FreshDesk
    FreshworksWidget('identify', 'ticketForm', {
      name: `${auth.account.firstName} ${auth.account.lastName}`,
      email: auth.account.emailAddress,
    })
  })
})
